import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  template: `<div class="error-danger" [class.hide]="hide">{{ text }}</div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./rx-control-error.component.scss'],
})
export class RxControlErrorComponent implements OnInit {
  public hide = true;

  @Input()
  public set text(value) {
    if (value !== this.text) {
      this._text = value;
      this.hide = !value;
      this._cdr.detectChanges();
    }
  }

  public get text() {
    return this._text;
  }

  private _text: string;

  constructor(private _cdr: ChangeDetectorRef) {}

  public ngOnInit() {}
}
